import axios from "axios";
import { configUrl } from "config";



const ProgramService = {
    createProgram: async (payload) => {
        const res = await axios.post(`${configUrl.AssessmentServer}/api/Program/create`, payload);
        return res.data;
    },
    bulkCreatePrograms: (payload) => {
        return axios.post(
            `${configUrl.AssessmentServer}/api/Program/bulkCreatePrograms`,
            payload
        );
    },

    addSlab: async (programId, payload) => {
        const res = await axios.post(
            `${configUrl.AssessmentServer}/api/Program/${programId}/addSlab`,
            payload
        );
        return res.data;
    },
    updateProgram: async (programId, payload) => {
        const res = await axios.put(`${configUrl.AssessmentServer}/api/Program/update/${programId}`, payload);
        return res.data;
    },
    updateProgramWithSlabs: async (programId, payload) => {
        const res = await axios.put(
            `${configUrl.AssessmentServer}/api/Program/updateProgramSlabs/${programId}`,
            payload
        );
        return res.data;
    },
    addBatch: async (programId, payload) => {
        const response = await axios.post(`${configUrl.AssessmentServer}/api/program/${programId}/addBatch`, payload);
        return response?.data;
    },
    updateBatch: async (batchId, payload) => {
        return axios.put(`${configUrl.AssessmentServer}/api/program/updateBatch/${batchId}`, payload);
    },
    getProgramBatches: async (programId) => {
        return axios.get(`${configUrl.AssessmentServer}/api/program/getProgrambatches/${programId}`);
    }

};

export default ProgramService;
